import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableCell, TableHead, TableRow, TableBody, TableSortLabel, Paper } from '@material-ui/core';
import moment from 'moment';
import { dayMonthDateFormat } from "../../../constants";
import { Link } from "react-router-dom";
import { checkApiStatus } from '../../../utils';
import { EmptyCollection, PageLoader } from '../../../shared_elements';
import Pagination from '../../../shared_elements/components/Pagination';
import { globalGetService, globalExportService } from '../../../utils/globalApiServices';
import { downloadFileType, convertToYearMonth } from "../../../utils";
import ExportMenu from '../../../shared_elements/components/ExportMenu';
import { smbcInstance } from '../../../shared_elements/components';

function UnderlyingChartData({ onClose, assetData }) {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [leaseStatusData, setLeaseStatusData] = useState({ results: [], pagination: {} });
    const [onOffWingData, setOnOffWingData] = useState({ results: [], pagination: {} });
    const [svData, setSvData] = useState({ results: [], pagination: {} });
    const [lessMore, setLessMore] = useState({});

    const statusOption = [
        { label: "On Lease", value: 1 },
        { label: "Off Lease", value: 2 },
        { label: "On Ground", value: 3 },
        { label: "Written Off / Sold / Part out", value: 4 },
        { label: "Archive", value: 5 },
    ];
    const OnOffWingOption = [
        { label: "In Shop Serviceable", value: 2 },
        { label: "In Shop UnServiceable", value: 3 },
        { label: "Off Wing Serviceable", value: 4 },
        { label: "Off Wing UnServiceable", value: 5 },
    ];

    const formattedDate = convertToYearMonth(assetData?.data);

    useEffect(() => {
        if (assetData?.type === "on-Off") {
            if (assetData?.data === "On Wing") {
                getOnOffWingData({ per_page: 250, on_wing_status: "True" });
            } else {
                getOnOffWingData({
                    per_page: 250,
                    on_wing_status: "False",
                    off_wing_status: OnOffWingOption.filter(i => i?.label === assetData?.data).map(i => i?.value)[0],
                });
            }
        } else if (assetData?.type === "sv") {
            getSVData({ sv_date_list: formattedDate, per_page: 250 });
        } else {
            getLeaseStatusData({
                ...filter,
                status: statusOption.filter(i => i?.label === assetData?.data).map(i => i?.value)[0],
                per_page: 250,
            }, 'pageloader');
        }
    }, []);

    const createSortHandler = (key, module) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' };
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' };
        }
        setSortInfo(sortQuery);
        if (module === 'on-Off') {
            getOnOffWingData({ ...filter, ...sortQuery, page: 1, per_page: onOffWingData?.pagination?.per_page }, 'pageLoader');
        } else if (module === 'sv') {
            getSVData({ ...filter, ...sortQuery, page: 1, per_page: svData?.pagination?.per_page, sv_date_list: formattedDate }, 'pageLoader');
        } else {
            getLeaseStatusData({ ...filter, ...sortQuery, page: 1, per_page: leaseStatusData?.pagination?.per_page }, 'pageLoader');
        }
    };

    const getLeaseStatusData = (query) => {
        setLoading(true);
        globalGetService(`camo/smbc_dashboard/asset_list/`, { ...query })
            .then(response => {
                if (checkApiStatus(response)) {
                    setLeaseStatusData(response.data);
                    delete query.page;
                    delete query.per_page;
                    setFilter(query);
                }
                setLoading(false);
            });
    };

    const getOnOffWingData = (query) => {
        setLoading(true);
        globalGetService(`camo/smbc_dashboard_on_off/list/`, { ...query })
            .then(response => {
                if (checkApiStatus(response)) {
                    setOnOffWingData(response?.data);
                    setFilter(query);
                }
                setLoading(false);
            });
    };

    const getSVData = (query) => {
        setLoading(true);
        globalGetService(`camo/smbc_dashboard/sv_date/`, { ...query })
            .then(response => {
                if (checkApiStatus(response)) {
                    setSvData(response?.data);
                }
                setLoading(false);
            });
    };

    const exportAssetsListing = (extension) => {
        setLoading(true);
        const queryParams = sortInfo?.sort === '' && sortInfo?.sort_by === ''
            ? Object.assign({}, filter)
            : Object.assign({}, filter, sortInfo);
        globalExportService(`camo/smbc_dashboard/asset_list/`, { ...queryParams, download: extension })
            .then(response => {
                setLoading(false);
                enqueueSnackbar(`${assetData?.data} Download successfull`, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                downloadFileType(response.data, `${assetData?.data}`, extension);
            });
    };

    const exportOnOffWing = (extension) => {
        let query = sortInfo?.sort === '' && sortInfo?.sort_by === ''
            ? Object.assign({}, filter, delete filter?.per_page, delete filter?.page)
            : Object.assign({}, filter, sortInfo, delete filter?.per_page, delete filter?.page);
        const queryParams = assetData?.data === "On Wing"
            ? { on_wing_status: "True", ...query }
            : { ...query, on_wing_status: "False", off_wing_status: OnOffWingOption.filter(i => i?.label === assetData?.data).map(i => i?.value)[0] };
        setLoading(true);
        globalExportService(`camo/smbc_dashboard_on_off/list/`, { ...queryParams, download: extension })
            .then(response => {
                setLoading(false);
                enqueueSnackbar(`${assetData?.data} Download successfull`, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                downloadFileType(response.data, `${assetData?.data}`, extension);
            });
    };

    const exportShopVisit = (extension) => {
        const queryParams = sortInfo?.sort === '' && sortInfo?.sort_by === ''
            ? Object.assign({}, filter)
            : Object.assign({}, filter, sortInfo);
        setLoading(true);
        globalExportService(`camo/smbc_dashboard/sv_date/`, { ...queryParams, sv_date_list: formattedDate, download: extension })
            .then(response => {
                setLoading(false);
                enqueueSnackbar("Download of Shop Visits List successfull", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                downloadFileType(response.data, 'Shop Visits_list', extension);
            });
    };

    const rowClick = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        return smbcInstance
            ? window.open(`${item?.id}/${item?.asset_type}/tech_spec/list`, '_blank')
            : window.open(`${item?.id}/${item?.asset_type}/ad/list`, '_blank');
    };

    const onCloseModal = () => { onClose(); };

    const toggleLessMore = (key) => {
        setLessMore(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const lessMoreFn = (name, key) => {
        if (!name || name.length <= 35) return name || '--';
        return (
            <>
                {lessMore[key] ? (
                    <>
                        {name}
                        <span className="less-more-link" onClick={(e) => { e.preventDefault(); toggleLessMore(key); }}> ..less</span>
                    </>
                ) : (
                    <>
                        {name.substring(0, 35)}
                        <span className="less-more-link" onClick={(e) => { e.preventDefault(); toggleLessMore(key); }}> ..more</span>
                    </>
                )}
            </>
        );
    };

    const sortHeader = (key, label, module, minWidth) => (
        <TableCell style={minWidth ? { minWidth } : undefined}>
            <TableSortLabel
                active={sortInfo.sort === key}
                direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'}
                onClick={() => createSortHandler(key, module)}
                className="col-align-center"
            >
                {label}
            </TableSortLabel>
        </TableCell>
    );

    const dialogHeight = (hasData) => ({ height: hasData ? 'auto' : `${window.innerHeight - 250}px`, overflow: 'auto' });

    return (
        <>
            {/* Lease Status Dialog */}
            <Dialog open={assetData?.type === "lease"} onClose={onClose} maxWidth="sm" className="dashboard-dialogue">
                <DialogTitle >
                    {assetData?.data}
                    <ul className="list-inline dialog-title-actions">
                        <li className="list-inline-item">
                            <ExportMenu exportReportFn={(file) => exportAssetsListing(file.extension)} files={[{ title: 'EXCEL', extension: 'xlsx' }]} />
                        </li>
                    </ul>
                </DialogTitle>
                <DialogContent dividers>
                    <Paper className="major-assemblies-list">
                        <div style={dialogHeight(!leaseStatusData?.results?.length)}>
                            <Table className="mui-table-format" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {sortHeader('engine_type', 'Type and Model', null, null)}
                                        {sortHeader('esn', 'ESN', null, null)}
                                        {sortHeader('lessee', 'Lessee', null, null)}
                                        {sortHeader('operator', 'Operator', null, null)}
                                        {sortHeader('status', 'Lease Status', null, null)}
                                        {sortHeader('on_wing_msn', 'Current Status', null, 150)}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {leaseStatusData?.results.map((item, index) => (
                                        <TableRow key={index} className="cursor-pointer" onClick={(e) => rowClick(e, item)}>
                                            <TableCell style={{ minWidth: '110px' }}>
                                                <span>{item?.engine_type?.name || ''}</span>
                                                {item?.owner?.name === "Managed" && (
                                                    <span className="managed-badge">Managed</span>
                                                )}
                                            </TableCell>
                                            <TableCell>{item?.esn ? item.esn : item?.asset_name || "--"}</TableCell>
                                            <TableCell>{item?.lessee || "--"}</TableCell>
                                            <TableCell>{item?.operator || "--"}</TableCell>
                                            <TableCell>
                                                <div className="status-cell-content">
                                                    {item?.status?.label && (
                                                        <span className={`asset-status status-${item.status.value}`}>{item.status.label}</span>
                                                    )}
                                                    {item?.sub_status?.label && (
                                                        <p className="para-text sub-status-bg">{item.sub_status.label}</p>
                                                    )}
                                                </div>
                                            </TableCell>
                                            <TableCell>{item?.on_wing_status ? (item?.on_wing_msn || "On Wing") : "Off Wing"}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        <Pagination
                            pagination={leaseStatusData?.pagination}
                            onChangePage={(event, newPage) => getLeaseStatusData({ ...filter, page: newPage + 1, per_page: leaseStatusData?.pagination?.per_page }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getLeaseStatusData({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                        {!leaseStatusData?.results?.length && (
                            <div className="empty-center"><EmptyCollection title="No records found" /></div>
                        )}
                        </div>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} variant="outlined" size='small' color="primary">CLOSE</Button>
                </DialogActions>
            </Dialog>

            {/* On/Off Wing Dialog */}
            <Dialog open={assetData?.type === "on-Off"} maxWidth="sm" className="dashboard-dialogue on-Off">
                <DialogTitle >
                    {assetData?.data}
                    <ul className="list-inline dialog-title-actions">
                        <li className="list-inline-item">
                            <ExportMenu exportReportFn={(file) => exportOnOffWing(file.extension)} files={[{ title: 'EXCEL', extension: 'xlsx' }]} />
                        </li>
                    </ul>
                </DialogTitle>
                <DialogContent dividers>
                    <Paper className="major-assemblies-list">
                        <div style={dialogHeight(!onOffWingData?.results?.length)}>
                            <Table className="mui-table-format" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {assetData?.data === "On Wing"
                                            ? sortHeader('on_wing_msn', 'On Wing MSN', 'on-Off', null)
                                            : sortHeader('off_wing_status', 'Wing Status', 'on-Off', null)
                                        }
                                        {sortHeader('lessee', 'Lessee', 'on-Off', null)}
                                        {sortHeader('operator', 'Operator', 'on-Off', null)}
                                        {sortHeader('esn', 'ESN', 'on-Off', null)}
                                        {assetData?.data !== "On Wing" && sortHeader('current_operating_thrust', 'Current Operating Thrust', 'on-Off', 180)}
                                        {sortHeader('last_utilization_updated', 'Last Utilization Update', 'on-Off', 190)}
                                        {sortHeader('status', 'Status', 'on-Off', 90)}
                                        {sortHeader('location', 'Location', 'on-Off', 80)}
                                        {assetData?.data !== "On Wing" && sortHeader('reason_for_removal', 'Reason of Removal', 'on-Off', 200)}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {onOffWingData?.results.map((item, index) => (
                                        <TableRow key={index} className="cursor-pointer">
                                            {assetData?.data === "On Wing"
                                                ? <TableCell onClick={(e) => rowClick(e, item)}>{item?.on_wing_msn || '--'}</TableCell>
                                                : <TableCell onClick={(e) => rowClick(e, item)}>{item?.off_wing_status?.label || '--'}</TableCell>
                                            }
                                            <TableCell onClick={(e) => rowClick(e, item)}>{item?.lessee || '--'}</TableCell>
                                            <TableCell onClick={(e) => rowClick(e, item)}>{item?.operator || '--'}</TableCell>
                                            <TableCell onClick={(e) => rowClick(e, item)}>{item?.esn || '--'}</TableCell>
                                            {assetData?.data !== "On Wing" && (
                                                <TableCell onClick={(e) => rowClick(e, item)}>{item?.current_operating_thrust?.name || '--'}</TableCell>
                                            )}
                                            <TableCell onClick={(e) => rowClick(e, item)}>{item?.last_utilization_updated ? moment(item.last_utilization_updated).format(dayMonthDateFormat) : '--'}</TableCell>
                                            <TableCell onClick={(e) => rowClick(e, item)}>{item?.status?.label || '--'}</TableCell>
                                            <TableCell onClick={(e) => rowClick(e, item)}>{item?.location || '--'}</TableCell>
                                            {assetData?.data !== "On Wing" && (
                                                <TableCell>{lessMoreFn(item?.off_wing_detail?.reason_for_removal, "reason_for_removal")}</TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        
                        <Pagination
                            pagination={onOffWingData?.pagination}
                            onChangePage={(event, newPage) => getOnOffWingData({ ...filter, page: newPage + 1, per_page: onOffWingData?.pagination?.per_page }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getOnOffWingData({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                        {!onOffWingData?.results?.length && (
                            <div className="empty-center"><EmptyCollection title="No records found" /></div>
                        )}
                        </div>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCloseModal} variant="outlined" size='small' color="primary">CLOSE</Button>
                </DialogActions>
            </Dialog>

            {/* Shop Visits Dialog */}
            <Dialog open={assetData?.type === "sv"} onClose={onClose} maxWidth="sm" className="dashboard-dialogue">
                <DialogTitle >
                    Shop Visits
                    <ul className="list-inline dialog-title-actions">
                        <li className="list-inline-item">
                            <ExportMenu exportReportFn={(file) => exportShopVisit(file.extension)} files={[{ title: 'EXCEL', extension: 'xlsx' }]} />
                        </li>
                    </ul>
                </DialogTitle>
                <DialogContent dividers>
                    <Paper className="major-assemblies-list">
                        <div style={dialogHeight(!svData?.results?.length)}>
                            <Table className="mui-table-format" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {sortHeader('engine_type_name', 'Engine Type', 'sv', null)}
                                        {sortHeader('esn', 'ESN', 'sv', null)}
                                        {sortHeader('lessee', 'Lessee', 'sv', null)}
                                        {sortHeader('operator', 'Operator', 'sv', null)}
                                        {sortHeader('sv_forecast_date', 'SV Forecast Date', 'sv', null)}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {svData?.results.map((item, index) => (
                                        <TableRow key={index} className="cursor-pointer" onClick={(e) => rowClick(e, item)}>
                                            <TableCell>{item?.engine_type_name || '--'}</TableCell>
                                            <TableCell>{item?.esn || '--'}</TableCell>
                                            <TableCell>{item?.lessee || '--'}</TableCell>
                                            <TableCell>{item?.operator || '--'}</TableCell>
                                            <TableCell>{item?.sv_forecast_date ? moment(item.sv_forecast_date).format(dayMonthDateFormat) : '--'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        <Pagination
                            pagination={svData?.pagination}
                            onChangePage={(event, newPage) => getSVData({ ...filter, page: newPage + 1, per_page: svData?.pagination?.per_page, sv_date_list: formattedDate }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getSVData({ ...filter, page: 1, per_page: event.target.value, sv_date_list: formattedDate }, 'pageLoader')}
                        />
                        {!svData?.results?.length && (
                            <div className="empty-center"><EmptyCollection title="No records found" /></div>
                        )}
                         </div>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} variant="outlined" color="primary" size='small'>CLOSE</Button>
                </DialogActions>
            </Dialog>

            {isLoading && <PageLoader />}
        </>
    );
}

export default UnderlyingChartData;
